export default __webpack_public_path__ + "static/media/ic_paid.e4efeb41.png";